import styles from './localizationLoadingSkeleton.module.scss';

const LocalizationLoadingSkeleton = () => {
  return (
    <div
      className={styles.container}
      data-testid='localization-environment-loading-skeleton'
      aria-busy='true'
      aria-label='Loading location and environment'
    >
      <div className={styles.map} data-testid='localization-map-skeleton'>
        <span className={styles.mapMarker} />
      </div>

      <section className={styles.locationInfo} aria-label='Loading location summary'>
        {Array.from({ length: 4 }, (_, index) => (
          <div
            className={styles.infoCard}
            data-testid='localization-info-card-skeleton'
            key={`info-card-${index}`}
          >
            <span className={styles.icon} />
            <span className={styles.label} />
            <span className={styles.value} />
          </div>
        ))}
      </section>

      <section className={styles.section} aria-label='Loading additional towns'>
        <span className={styles.heading} />
        <div className={styles.rows}>
          <span className={styles.row} />
          <span className={styles.rowShort} />
        </div>
      </section>

      <section className={styles.section} aria-label='Loading protected spaces'>
        <span className={styles.heading} />
        <div className={styles.largePanel}>
          <span className={styles.panelLine} />
          <span className={styles.panelLineShort} />
        </div>
      </section>

      <div className={styles.halvedSection}>
        {Array.from({ length: 2 }, (_, index) => (
          <section
            className={styles.section}
            aria-label={`Loading environmental section ${index + 1}`}
            key={`environment-section-${index}`}
          >
            <span className={styles.heading} />
            <div className={styles.largePanel}>
              <span className={styles.panelLine} />
              <span className={styles.panelLineShort} />
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default LocalizationLoadingSkeleton;
